import { ApplicationTargetEnum } from '~types/app-selection';

const parseProvincesCsv = (provinces?: string): string[] => {
    if (!provinces) {
        return [];
    }
    return provinces
        .split(',')
        .map((province) => province.trim())
        .filter(Boolean);
};

export const getDefaultProvinces = (
    appTarget: ApplicationTargetEnum | undefined,
    provincesCsv?: string
): string[] => {
    if (appTarget === ApplicationTargetEnum.QC) {
        return [ApplicationTargetEnum.QC];
    }
    return parseProvincesCsv(provincesCsv);
};

export const resolveProvincesSelection = (params: {
    isQcTarget: boolean;
    defaultProvinces: string[];
    selection: string[];
}): string[] => {
    if (params.isQcTarget) {
        return params.defaultProvinces;
    }
    return params.selection.length > 0
        ? params.selection
        : params.defaultProvinces;
};

export const areProvincesEqual = (left: string[], right: string[]): boolean => {
    if (left.length !== right.length) {
        return false;
    }
    for (let i = 0; i < left.length; i += 1) {
        if (left[i] !== right[i]) {
            return false;
        }
    }
    return true;
};
